import { render, staticRenderFns } from "./MyTradeJournalItem.vue?vue&type=template&id=b33313fc&"
import script from "./MyTradeJournalItem.vue?vue&type=script&lang=js&"
export * from "./MyTradeJournalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports